var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSustainability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M42.75,41.3l-7.1-8.777h3.838a.8.8,0,0,0,.7-.434.753.753,0,0,0-.087-.814L29.615,17.729A.771.771,0,0,0,29,17.422a.753.753,0,0,0-.614.307l-10.5,13.543a.769.769,0,0,0-.087.814.786.786,0,0,0,.7.434H22.34l-7.1,8.784a.78.78,0,0,0,.607,1.268H28.22V47.8a.781.781,0,0,0,1.562,0V42.571H42.15a.77.77,0,0,0,.7-.441.792.792,0,0,0-.093-.828Z",
    transform: "translate(-13 -16.578)",
    fill: "#8e50a7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSustainability);
export default __webpack_public_path__ + "static/media/icon-sustainability.5b383338c5139efd94efb6a85f211eaf.svg";
export { ForwardRef as ReactComponent };